export const status = {
    0: 'Диспетчер',
    1: 'Администратор',
    2: 'Супервайзер',
    3: 'Супер Администратор',
}

export const statusArray = Object.entries(status);